import React from 'react';

import ReduxConnect from 'Demora/redux-connect';

import './Profile.css';

import Feed from './Feed/Feed';

import Followers from '../Relationships/Followers/Followers';

import FollowButton from '../Relationships/Followers/FollowButton';

import Image from 'Demora/image';

import SendMessageButton from '../../../../../../../../../react-messages/src/resources/assets/js/src/app/Auth/Messages/SendMessageButton';

import classnames from 'classnames';

import socialHttp from '../../../utils/socialHttp';

import getObjId from 'Demora/getObjId';

import Loading from 'Demora/Loading';

import ProfileHeader from 'resources/assets/react-app/uiHooks/react-social/profileHeader';

import ProfileFirstBlock from 'resources/assets/react-app/uiHooks/react-social/profileFirstBlock';

import ProfileNextToName from 'resources/assets/react-app/uiHooks/react-social/profileNextToName';

import ProfileUnderProfileImage from 'resources/assets/react-app/uiHooks/react-social/profileUnderProfileImage';

import ProfileTabs from 'resources/assets/react-app/uiHooks/react-social/profileTabs';

import getFeels, { areFeelsLoaded } from './GetFeels';

import Group from './Groups/Group';

import { withRouter } from 'react-router-dom';

import ProfileSettings from './ProfileSettings/ProfileSettingsButton';

import Tabs from 'Demora/Tabs';

import 'custom-event-polyfill';

import { Scrollbars } from 'react-custom-scrollbars-2';

import pusher from 'Demora/../pusher';

class Profile extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			apiToken: new URLSearchParams(props.location.search).get('socApiToken'),
			getting: {},
			obj: null,
			tabs: undefined,
		};
	}

	componentDidMount() {
		this.setObject(this.props.match.params.obj);
	}

	setObject(obj, force) {
		const props = this.props;

		if (!force && obj && obj == this.state.obj) {
			return;
		}

		if (!obj) {
			obj = props.user.id + '-u';
		}

		if (
			!force &&
			this.props.users[this.state.obj] &&
			obj == this.props.users[this.state.obj].username
		) {
			return;
		}

		this.leaveChannel();

		this.setState(
			{
				obj: obj,
			},
			() => {
				this.getDataAfterMount();
				this.setTabs();
			}
		);
	}

	getDataAfterMount = () => {
		this.getFirstData();

		getFeels();
	};

	componentDidUpdate(prevProps) {
		const state = this.state;

		const { obj } = state;

		const props = this.props;

		const { match } = props;

		const { params } = match;

		if (
			(params.obj &&
				params.obj != obj &&
				(!props.users[obj] ||
					(props.users[obj] && props.users[obj].username !== params.obj))) ||
			(!params.obj && props.user.id + '-u' != obj) ||
			props.location.key != prevProps.location.key
		) {
			this.setObject(params.obj, true);
		}
	}

	channelName() {
		return 'SOCIAL_' + this.state.obj.replace('-', '_');
	}

	getFirstData() {
		const state = this.state;

		const props = this.props;

		const obj = state.obj;

		if (state.getting[obj]) {
			return;
		}

		state.getting[obj] = true;

		this.getData().then(() => {
			const props = this.props;
			if (props.feed[obj] && props.users[obj] && props.user.id) {
				pusher
					.private(this.channelName())
					.listen('.relationship_follow', this.pusher_relationship_follow)
					.listen('.new_post', this.pusher_new_post)
					.listen('.new_share', this.pusher_new_share)
					.listen('.new_comment', this.pusher_new_comment)
					.listen('.change_feel', this.pusher_change_feel)
					.listen('.delete_post', this.pusher_delete_post);

				const ce = new CustomEvent('react_social_view_profile', {
					view: window,
					bubbles: true,
					detail: {
						obj: props.feed[obj].h,
					},
				});

				document.dispatchEvent(ce);
			}
		});
	}

	leaveChannel() {
		if (this.state.obj) {
			pusher.leave(this.channelName());
		}
	}

	pusher_relationship_follow = (data) => {
		this.storeFeed(data.data);

		Object.keys(data.data.feed).map((u1) => {
			Object.keys(data.data.feed[u1].followers.p).map((u2) => {
				if (u2 == this.props.user.id + '-u') {
					const d = {
						users: {},
					};

					d.users[u1] = {
						r: {
							fing: !data.data.feed[u1].followers.p[u2].d,
						},
					};

					this.storeFeed(d);
				}
			});
		});
	};

	pusher_change_feel = (data) => {
		this.updateFeed(data.data);
	};

	pusher_delete_post = (data) => {
		this.updateFeed(data.data);
	};

	pusher_new_post = (data) => {
		this.getData();
	};

	pusher_new_share = (data) => {
		this.getData();
	};

	pusher_new_comment = (data) => {
		const commentId = getObjId(data.data.commentId);

		if (this.props.feed[commentId.rootObj].p[commentId.parentObj]) {
			this.getData();
		}
	};

	storeFeed(data) {
		this.props.dispatch({
			type: 'STORE_FEED',
			data: data,
		});
	}

	updateFeed(data) {
		this.props.dispatch({
			type: 'UPDATE_FEED',
			data: data,
		});
	}

	getData() {
		const state = this.state;

		const props = this.props;

		const obj = state.obj;

		let qt = '';

		if (state.apiToken) {
			qt = '&socApiToken=' + state.apiToken;

			import(
				/* webpackChunkName: "auth_stuff" */ '@fortawesome/fontawesome-free/css/all.css'
			);
		}

		return socialHttp('get', '/data/profile/' + obj + '?limit=3' + qt)
			.then((data) => {
				state.getting[obj] = false;

				if (!props.feed[obj]) {
					const users = Object.keys(props.users);

					for (let i = 0; i < users.length; i++) {
						const u = props.users[users[i]];

						if (u && u.username == obj) {
							this.setObject(users[i]);
						}
					}
				}
				setTimeout(this.setTabs, 1);
			})
			.catch((e) => {
				throw e;
			});
	}

	componentWillUnmount() {
		this.leaveChannel();
	}

	setTabs = () => {
		const obj = this.state.obj;

		const tabs = [
			{
				title: 'Posts',
				pane: <Feed match={this.props.match} obj={obj} />,
			},
		].concat(ProfileTabs(obj) ?? []);

		this.setState({
			tabs,
		});
	};

	render() {
		const props = this.props;

		const state = this.state;

		const obj = state.obj;

		if (obj && obj.split('-')[1] == 'g') {
			return <Group obj={props.match.params.obj} />;
		}

		const feed = props.feed[obj];

		const tabs = state.tabs;

		if (!areFeelsLoaded() || !feed || feed.can === undefined || !tabs) {
			return (
				<div
					className='card panel-white post panel-shadow text-center'
					style={{ padding: '30px 0' }}
				>
					<Loading />
				</div>
			);
		}

		const user = props.users[obj];

		if (!user) {
			return (
				<div className='container social_profile'>
					<div className='row'>
						<div className='col-md col-12 text-center'>User doesn't exist</div>
					</div>
				</div>
			);
		}

		const buttons =
			obj == props.user.id + '-u' || !props.user.id ? (
				<span></span>
			) : (
				<div className='row text-center mt-2 mb-2'>
					<div className='col-6'>
						{feed.can.message && <FollowButton obj={obj} />}
					</div>
					<div className='col-6'>
						{!feed.can.message ? (
							<FollowButton obj={obj} />
						) : (
							<SendMessageButton obj={obj} />
						)}
					</div>
				</div>
			);

		return (
			<div className='container social_profile'>
				<div className='row'>
					<div className='col-md col-12'>
						<div className='row mb-1'>
							<div className='col profile-photo-container'>
								<img
									src={!user ? '' : Image(user.image, 200)}
									className='profile-photo rounded show-in-modal'
									style={{ padding: '2px', border: 'solid 1px #bbb' }}
								/>
								<ProfileUnderProfileImage obj={obj} />
							</div>
							<div className='col profile-opts'>
								<div>
									<span className='user-name'>
										{user.first_name + ' ' + user.last_name}
									</span>

									<ProfileNextToName obj={obj} />
								</div>

								<div className='d-sm-none'>{buttons}</div>

								<ProfileHeader obj={obj} />

								<div className='text-right'>
									<ProfileSettings obj={obj} />
								</div>

								<div className='maxW500 mx-auto'>
									<div className='d-none d-lg-block'>{buttons}</div>
								</div>
							</div>
						</div>

						<ProfileFirstBlock obj={obj} />

						<div className='d-none d-sm-block d-lg-none'>{buttons}</div>

						<div className={classnames('animated fadeIn mt-3')}>
							{!!tabs && tabs.length === 1 ? (
								tabs[0].pane
							) : (
								<Tabs uri={'/profile/' + obj} tabs={tabs} />
							)}

							{false && (
								<div className='col-12'>
									<div className='row'>
										<div className='col-lg-12'>
											<div className='card panel-user-detail'>
												<div className='card-body'>
													<ul className='list-unstyled'>
														<li>
															<i className='fa fa-suitcase'></i>Works at{' '}
															<a href='#'>software development</a>
														</li>
														<li>
															<i className='fas fa-calendar-alt'></i>Born on
															August 12, 1991
														</li>
														<li>
															<i className='fa fa-rss'></i>Followed by{' '}
															<a href='#'>51 People</a>
														</li>
													</ul>
												</div>
												<div className='card-footer text-center'>
													{' '}
													<a href='#'>
														<i className='fa fa-share'></i>Read more...
													</a>{' '}
												</div>
											</div>
										</div>
									</div>
								</div>
							)}
						</div>
						<div className='space'></div>
					</div>
					<div className='col-md-250'>
						<div className='followers_container'>
							<Scrollbars
								style={{ height: '100%', width: '100%', overflowX: 'hidden' }}
							>
								<Followers obj={obj} />
							</Scrollbars>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

Profile = withRouter(
	ReduxConnect(Profile, {
		user: 'user',
		feed: 'feed',
		feels: 'feels',
		users: 'users',
		usersByUsernames: 'usersByUsernames',
	})
);

export default Profile;
